module.exports = __webpack_public_path__ + "images/xllease_small4d969ce47235f30a9b427cb117670496.png";